import { useState } from "react";
import WalletSidebar from "../../components/Wallet/WalletSidebar";
import WalletPinManagement from "../../components/Wallet/WalletPinManagement";
import ManagePayoutAccounts from "../../components/Wallet/ManagePayoutAccounts";
import AlertPreferences from "../../components/Wallet/AlertPreferences";
// import WalletActivityLog from "../../components/Wallet/WalletActivityLog";

const WalletSetting = () => {
  const [activeTab, setActiveTab] = useState("wallet-pin");

  // Helper function to render tab content
  const renderContent = () => {
    switch (activeTab) {
      case "wallet-pin":
        return <WalletPinManagement />;
      case "payout-accounts":
        return <ManagePayoutAccounts />;
      case "alert-preferences":
        return <AlertPreferences />;
      // case "activity-log":
      //   return <WalletActivityLog />;
      default:
        return <WalletPinManagement />;
    }
  };

  // Helper function to render dynamic header
  const getHeaderTitle = () => {
    switch (activeTab) {
      case "wallet-pin":
        return "Wallet PIN";
      case "payout-accounts":
        return "Manage Payout Accounts";
      case "alert-preferences":
        return "Alert Preferences";
      // case "activity-log":
      //   return "Wallet Activity Log";
      default:
        return "Wallet Settings";
    }
  };

  return (
    <div className="flex flex-col md:flex-row p-6 border border-gray-300 rounded-[10px] shadow-sm">
      {/* Sidebar */}
      <WalletSidebar activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* Content */}
      <div className="flex-1 bg-white rounded-lg shadow-sm">
        {/* Header */}
        <div className="bg-blue-900 text-white px-6 py-4 rounded-tr-[8px]">
          <h2 className="text-lg font-semibold">{getHeaderTitle()}</h2>
        </div>

        {/* Content area */}
        <div className="p-6">{renderContent()}</div>
      </div>
    </div>
  );
};

export default WalletSetting;
